import React from "react";
import { useBusinessNonMockEntityIds } from "@hooks/useBusinessEntityIds";
import { useWarmLedgerCaches } from "@api/ledger.api";
import { AccountingTabContext, useAccountingTab } from "./useAccountingTab";

export const AccountingTabProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const accountingTab = useAccountingTab();

    // Warm ledger caches for the accounting section so reports resolve a valid
    // ledger synchronously when switching entities (no per-switch fetch). Uses
    // the same business/non-mock entity set the reports look ledgers up by, so
    // the cache keys match.
    useWarmLedgerCaches(useBusinessNonMockEntityIds());

    return (
        <AccountingTabContext.Provider value={accountingTab}>
            {children}
        </AccountingTabContext.Provider>
    );
};
